import { Button, Heading, Icon, Link, ListItem, ListUnordered, Paragraph } from '@innovationnorway/cl-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { errorBoundary } from '../../assets/localizations/localizationsErrorBoundary';
import { useDocumentTitle, useLocalizer } from '../../hooks';
import { queryClient } from '../../lib/query/tanStackQueryProvider';

export const ErrorPage = () => {
  const { typeSafeL } = useLocalizer('ErrorBoundary');
  const localization = typeSafeL<typeof errorBoundary>;
  useDocumentTitle(localization('title'));

  const navigate = useNavigate();
  const location = useLocation();
  const correlationId = location.state?.correlationId;

  const handleRetry = () => {
    queryClient.resetQueries();

    navigate(-1);
  };

  const handleReturnToPageBeforeError = () => {
    // Navigate back two steps to avoid landing on the erroneous page again
    navigate(-2);
  };

  const handleHome = () => {
    navigate('/');
  };

  return (
    <div className="flex flex-row justify-between mt-6">
      <div className="flex flex-col gap-12">
        <div className="flex flex-col gap-5">
          <Heading scale="md" level={1} data-size="xl">
            {localization('title')}
          </Heading>
          <Paragraph data-size="lg">{localization('message')}</Paragraph>
        </div>

        <div className="flex flex-col gap-2">
          <Heading level={2} data-size="xs">
            {localization('suggestionsTitle')}
          </Heading>
          <ListUnordered>
            <ListItem className="!mb-2">
              {localization('suggestionReloadPrefix')}{' '}
              <Link
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleRetry();
                }}
              >
                {localization('suggestionReloadLink')}
              </Link>
            </ListItem>
            <ListItem>
              <Link
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleReturnToPageBeforeError();
                }}
              >
                {localization('suggestionGoBackLink')}
              </Link>
            </ListItem>
          </ListUnordered>
        </div>

        <div>
          <Paragraph className="!mb-2">
            {localization('contactInfoPrefix')} <Link href={`mailto:kundesupport@innovasjonnorge.no`}>kundesupport@innovasjonnorge.no</Link>
          </Paragraph>
          <Paragraph>{localization('includeCorrelationIdInfo')}</Paragraph>
        </div>
        <div>
          {correlationId && (
            <Paragraph>
              {localization('correlationIdLabel')} {correlationId}
            </Paragraph>
          )}
        </div>

        <div className="flex gap-4">
          <Button onClick={handleRetry} variant="primary">
            {localization('tryAgainButton')}
          </Button>
          <Button variant="secondary" onClick={handleHome}>
            {localization('returnHomeButton')}
          </Button>
        </div>
      </div>
      <div className="hidden flex-1 lg:flex justify-center mt-4">
        <Icon iconName="BalancingBall" prefix="inno" size="3xl" />
      </div>
    </div>
  );
};
